import { CookieOptions } from './cookieTypes'

/**
 * Delete a cookie by setting its expiration date to the past
 * @param name - The name of the cookie to delete
 * @param options - Cookie options that must match the original cookie
 */
export function deleteCookie(name: string, options?: CookieOptions) {
  try {
    const pastDate = new Date(0) // Set to Unix epoch time (January 1, 1970)

    const attributes = [
      `expires=${pastDate.toUTCString()}`,
      options?.path ? `path=${options.path}` : 'path=/',
      options?.domain ? `domain=${options.domain}` : '',
      options?.secure ? 'secure' : '',
      options?.sameSite ? `samesite=${options.sameSite.toLowerCase()}` : '',
    ].filter(Boolean)

    // Set the cookie with an empty value and past expiration
    const cookieString = `${name}=; ${attributes.join('; ')}`
    document.cookie = cookieString

    // Debug logging
    console.log(`Attempting to delete cookie: ${name}`)
    console.log(`Cookie string: ${cookieString}`)

    // Verify deletion by checking if cookie still exists
    setTimeout(() => {
      const remainingCookies = document.cookie.split(';').map(c => c.trim())
      const cookieStillExists = remainingCookies.some(c => c.startsWith(`${name}=`))
      if (cookieStillExists) {
        console.warn(`Cookie ${name} may still exist after deletion attempt`)
      } else {
        console.log(`Cookie ${name} successfully deleted`)
      }
    }, 100)
  } catch (error) {
    console.error(`Error deleting cookie ${name}:`, error)
    throw new Error(`Error deleting cookie: ${error}`)
  }
}
